module.exports = __webpack_public_path__ + "img/7_200.5dab7ab9.png";